import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProblemSection() {
  return <section className="bg-gray-50 py-20 px-4 border-t border-gray-200" data-id="element-231">
      <div className="max-w-3xl mx-auto" data-id="element-232">
        <div className="text-center mb-10" data-id="element-233">
          <span className="text-neon font-bold text-sm tracking-widest uppercase bg-black px-4 py-1 rounded-full" data-id="element-234">
            — EL PROBLEMA REAL —
          </span>
        </div>

        <h2 className="text-3xl md:text-5xl font-extrabold text-black text-center leading-tight mb-12 font-montserrat" data-id="element-235">
          "El Mercado del UGC en España Tiene más Demanda que Oferta. Pero el
          95% de las Personas no Sabe que Existe."
        </h2>

        <div className="text-lg text-gray-800 space-y-6 mb-16 text-center md:text-left" data-id="element-236">
          <p data-id="element-237">
            Hay más de{' '}
            <strong className="text-black text-xl" data-id="element-238">
              12.000 marcas españolas
            </strong>{' '}
            buscando creadores UGC activamente.
          </p>
          <p data-id="element-239">
            Hay menos de{' '}
            <strong className="text-black text-xl" data-id="element-240">
              5.000 creadores activos
            </strong>{' '}
            en todo el país.
          </p>
          <p data-id="element-241">
            Eso significa que la demanda supera la oferta en una proporción de
            más de <strong className="text-black text-xl" data-id="element-242">2 a 1.</strong>
          </p>
          <p className="font-medium bg-yellow-100 p-4 rounded-lg border border-yellow-300" data-id="element-243">
            Y mientras tú lees esto, hay marcas en tu nicho que están pagando a
            creadores en otros países porque no encuentran suficientes en
            España.
          </p>
        </div>

        <div className="bg-red-900 border-4 border-white rounded-2xl p-8 md:p-12 shadow-2xl relative mb-16" data-id="element-244">
          <div className="flex items-center justify-center gap-3 mb-8 border-b border-red-800 pb-6" data-id="element-245">
            <AlertTriangle className="w-10 h-10 text-yellow-400" data-id="element-246" />
            <h3 className="text-2xl md:text-3xl font-black text-white tracking-tight" data-id="element-247">
              EL COSTE DE NO HACER NADA
            </h3>
          </div>

          <div className="text-white text-lg md:text-xl space-y-4" data-id="element-248">
            <p className="font-bold mb-6 text-center" data-id="element-249">
              Si no empiezas hoy, dentro de 6 meses:
            </p>
            <ul className="space-y-4" data-id="element-250">
              <li className="flex items-start gap-3" data-id="element-251">
                <span className="text-red-400 font-bold" data-id="element-252">→</span>
                <span data-id="element-253">Seguirás con el mismo sueldo que no llega</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-254">
                <span className="text-red-400 font-bold" data-id="element-255">→</span>
                <span data-id="element-256">Seguirás mirando el saldo con ansiedad</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-257">
                <span className="text-red-400 font-bold" data-id="element-258">→</span>
                <span data-id="element-259">Seguirás diciéndote "en algún momento empezaré"</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-260">
                <span className="text-red-400 font-bold" data-id="element-261">→</span>
                <span data-id="element-262">El mercado UGC en España estará más saturado</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-263">
                <span className="text-red-400 font-bold" data-id="element-264">→</span>
                <span data-id="element-265">Los precios por video habrán bajado</span>
              </li>
            </ul>

            <div className="mt-8 pt-8 border-t border-red-800 text-center" data-id="element-266">
              <p className="font-black text-2xl text-yellow-400 mb-2" data-id="element-267">
                La ventana de oportunidad está abierta AHORA.
              </p>
              <p className="font-bold" data-id="element-268">No estará abierta para siempre.</p>
            </div>
          </div>
        </div>

        <div className="mt-12" data-id="element-269">
          <CTAButton data-id="element-270" />
        </div>
      </div>
    </section>;
}